import { Offer } from 'interfaces/offers'
import { createPayloadAction, createRequestActionCreators, RequestAction } from 'helpers/actionsHelpers'
import { PayloadAction } from 'interfaces/action'

type GetOfferPayload = {
  id: Offer['id']
}
export const GET_OFFER = 'GET_OFFER' as const
type GetOffer = RequestAction<typeof GET_OFFER, GetOfferPayload, Offer>
export const getOfferActionCreator = createRequestActionCreators<typeof GET_OFFER, GetOfferPayload>(GET_OFFER)

export const OFFER_SHOWN = 'OFFER_SHOWN' as const
type OfferShown = PayloadAction<typeof OFFER_SHOWN, Offer>
export const offerShown = (payload: Offer): OfferShown =>
  createPayloadAction<typeof OFFER_SHOWN, Offer>(OFFER_SHOWN, payload)

export const OFFER_APPLY = 'OFFER_APPLY' as const
type OfferApply = PayloadAction<typeof OFFER_APPLY, Offer>
export const offerApply = (payload: Offer): OfferApply =>
  createPayloadAction<typeof OFFER_APPLY, Offer>(OFFER_APPLY, payload)

export type OfferActions =
  | GetOffer
  | OfferShown
  | OfferApply

export default OfferActions
